import styled from '@emotion/styled';

export const Container = styled.div`
  padding: 24px;
`;

export const Notification = styled.h3`
  margin: 0;
  font-weight: 600;
  font-size: 28px;
  color: red;
`;